import { Get_Token } from 'resolvers/Get_Token';
import apiService from './apiService';
import { cloneDeep } from 'lodash';

export async function getCard(id) {
    const response = await apiService.get(`/cards/${id}`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function getCards(queryParams = { last4: null, cardholders: [], page: 0, limit: 10 }) {
    const { last4, cardholders, page, limit } = queryParams;

    const response = await apiService.get('/cards', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params: {
            ...(last4 && { last4 }),
            ...(cardholders && { cardholders }),
            page,
            limit
        }
    });
    return response.data;
}

export async function createCard(data) {
    const response = await apiService.post('/cards', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function getCardInfo(id) {
    const response = await apiService.get(`/cards/${id}/unredact`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function testCard({ id, amount }) {
    const response = await apiService.post(
        `/cards/${id}/test`,
        {
            amount
        },
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export const updateStatusCard = async ({ id, isDeactivated }) => {
    const status = isDeactivated === 1 ? 'active' : 'inactive';

    const response = await apiService.patch(
        `/cards/${id}/status`,
        { status },
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
};

export const cancelCard = async id => {
    const response = await apiService.delete(`/cards/${id}`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};
export const replenishFunds = async (id, body) => {
    const response = await apiService.patch(`/cards/${id}/replenish`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const updateCard = async (card, id) => {
    const body = cloneDeep(card);
    const response = await apiService.patch(`/cards/${id}`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const getMccCodes = async () => {
    const response = await apiService.get(`/mcc`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    response.data
        .sort((first, second) => {
            const x = first.category.toLowerCase();
            const y = second.category.toLowerCase();
            if (x < y) {
                return -1;
            }
            if (x > y) {
                return 1;
            }
            return 0;
        })
        .filter(row => row.category !== '');
    return response.data;
};

export const activateCard = async (id, data) => {
    const response = await apiService.patch(`/cards/${id}/activate`, data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const addFunds = async (id, body) => {
    const response = await apiService.patch(`/cards/${id}/fund`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const updateCardTransactionMemo = async (id, body) => {
    const response = await apiService.patch(`/cards/transactions/${id}/memo`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const getCardTransaction = async id => {
    const response = await apiService.get(`/cards/transactions/${id}`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const uploadCardTransactionReceipts = async (id, body) => {
    const response = await apiService.post(`/cards/transactions/${id}/receipts`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const removeCardTransactionReceipt = async (id, receiptID) => {
    const response = await apiService.delete(`/cards/transactions/${id}/receipts/${receiptID}`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const updateCardTransaction = async (id, body) => {
    const response = await apiService.patch(`/cards/transactions/${id}`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const removeCardTransactionCategory = async id => {
    const response = await apiService.delete(`/cards/transactions/${id}/category`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const getCardTransactionChildren = async (id, queryParams) => {
    const response = await apiService.get(`/cards/transactions/${id}/children`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        },
        params: queryParams
    });
    return response.data;
};

export const requestCard = async body => {
    const response = await apiService.post(`/cards/requests`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const rejectCardRequest = async id => {
    const response = await apiService.delete(`/cards/requests/${id}/reject`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};

export const requestLimitChange = async (id, body) => {
    const response = await apiService.patch(`/cards/${id}/request-fund-change`, body, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
};
